import { render, staticRenderFns } from "./Categorie.vue?vue&type=template&id=fa9d855c"
import script from "./Categorie.vue?vue&type=script&lang=js"
export * from "./Categorie.vue?vue&type=script&lang=js"
import style0 from "./Categorie.vue?vue&type=style&index=0&id=fa9d855c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports